// extracted by mini-css-extract-plugin
export default {"hidden":"LoadingOverlay_hidden__dx0oI","overlay":"LoadingOverlay_overlay__LV2wo"};